var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.308594 0V29.8812H29.8642V0H0.308594ZM15.0864 10.4196C17.5911 10.4196 19.6199 12.4484 19.6199 14.9531C19.6199 17.4578 17.5911 19.4616 15.0864 19.4616C12.5817 19.4616 10.5529 17.4328 10.5529 14.9281C10.5529 12.4234 12.5817 10.4196 15.0864 10.4196ZM27.3595 27.3765H2.81331V2.50471H13.834V8.01508C10.5529 8.61621 8.04816 11.4716 8.04816 14.9281C8.04816 18.8104 11.2041 21.9663 15.0864 21.9663C18.9687 21.9663 22.1246 18.8104 22.1246 14.9281C22.1246 11.4716 19.6199 8.59116 16.3388 8.01508V2.50471H27.3595V27.3765Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngage);
export default __webpack_public_path__ + "static/media/engage.3fbbc4e9536a092e1ac4e2fb9d014cc6.svg";
export { ForwardRef as ReactComponent };